<template>
<div class="loading-spinner">
  <div></div>
  <div></div>
  <div></div>
  <div></div>
</div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
  @import "../scss/colors";

  $size: 30px;
  $speed: 1.2s;
  $color: $on-background;


  .loading-spinner {
    $delta: -.125;
    display: inline-block;
    position: relative;
    width: round($size);
    height: round($size);
    margin-bottom: -8px;

    & div {
      box-sizing: border-box;
      display: block;
      position: absolute;
      width: round($size * .8);
      height: round($size * .8);
      margin: round($size * .1);
      border: round($size * .05) solid $color;
      border-radius: 50%;
      animation: lds-ring $speed cubic-bezier(.5, 0, .5, 1) infinite;
      border-color: $color transparent transparent transparent;

      &:nth-child(1){
        animation-delay: $delta * 3 * $speed;
      }

      &:nth-child(2){
        animation-delay: $delta * 2 * $speed;
      }

      &:nth-child(3){
        animation-delay: $delta * 1 * $speed;
      }
    }

    @keyframes lds-ring {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }

  }
</style>
